module.exports = __webpack_public_path__ + "static/media/email.d169101f.svg";